// src/config.js
const GATEWAY_BASE_URL = process.env.REACT_APP_GATEWAY_BASE_URL;
// For SEO/Frontend links
const SITE_URL = process.env.REACT_APP_SITE_URL || 'https://aecblock.com';
// Client ID público del OAuth dedicado al login de clientes
const GOOGLE_AUTH_CLIENT_ID = process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID;

export const API_BASES = {
  gateway: GATEWAY_BASE_URL,
  users: `${GATEWAY_BASE_URL}/api/users`,
  products: `${GATEWAY_BASE_URL}/api/products`,
  orders: `${GATEWAY_BASE_URL}/api/orders`,
  stats: `${GATEWAY_BASE_URL}/api/stats`,
  files: `${GATEWAY_BASE_URL}/api/files`,
  auth: `${GATEWAY_BASE_URL}/api/auth`,
  contact: `${GATEWAY_BASE_URL}/api/users/contact`,
};

export { SITE_URL, GOOGLE_AUTH_CLIENT_ID };